<template>
  <product-list-page v-if="category" :category="category" />
</template>

<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue';
  import { createError, isNuxtError, useAsyncData, useNuxtApp, useRoute } from 'nuxt/app';
  import { useCategoryStore } from '~~/common/stores/category';
  import { useProductsStore } from '~~/common/stores/products';

  const ProductListPage = defineAsyncComponent(() => import('~~/common/components/Page/ProductList/AwProductListWrapperPage.vue'));

  defineOptions({
    name: 'ProductList',
  });

  const { $logger } = useNuxtApp();
  const { params } = useRoute();
  const categoryId = String(params.id);
  const categoryStore = useCategoryStore();
  const productsStore = useProductsStore();

  const category = computed(() => categoryStore.category ?? undefined);

  // run fetch if request: /product-list/{category-id}
  await useAsyncData(
    `product-list_${categoryId}`,
    async () => {
      try {
        await Promise.all([
          productsStore.fetchProducts({
            isCached: true,
            categoryId,
            itemsPerPage: productsStore.itemsPerPage || 16,
            filterParams: productsStore.filterBy,
            sortKey: productsStore.sortKey || null,
            sortBy: productsStore.sortBy || null,
            page: 1,
          }),
          categoryStore.fetchCategoryById(categoryId),
        ]);
      } catch (err) {
        if (isNuxtError(err)) {
          // `fetchCategoryById` reports an unknown category with `createError`.
          throw err;
        }
        $logger.error(err);
      }
      if (!categoryStore.category) {
        throw createError({
          statusCode: 404,
          fatal: true,
        });
      }
      return {};
    },
  );
</script>
